export type TutorialStep = keyof typeof rewards;

export const rewards = {
  basicGameplay: 100,
  chatWithPets: 100,
  careForPets: 100,
  petsGetSick: 100,
  friendReferral: 100,
  profile: 100,
  match3: 100,
  visitFriend: 100,
  adult: 100,
  duoInvite: 100,
  duoInviteReceived: 100,
};

export const TutorialSteps = Object.keys(rewards) as TutorialStep[];

export const version = '1.0.0';
